import { makeStyles } from '@material-ui/core/styles'
import { getTokenForQrReport } from 'src/services/individualService'
import { verifyPaymentStatus } from 'src/services/buyPolicyService'
import { useHistory, useLocation } from 'react-router-dom'
import React, { useCallback, useEffect, useState } from 'react'
import LoadingModal from 'src/components/common/LoadingModal'
import Verifying_Payment from 'src/assets/Buy_Policy_Images/Verifying_Payment_Status.json'
import Lottie from 'lottie-react'
import { COLORS } from 'src/utils/Themes/colors'
import { useDispatch } from 'react-redux'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import { PAYMENT_STATUS } from 'src/utils/constants/BuyPolicy'

const VerifyPaymentStatus = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const { search } = useLocation()

  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  const output = searchParams.get('Output')

  const fetchToken = useCallback(async () => {
    setLoading(true)
    try {
      const response = await getTokenForQrReport()
      if (response?.res?.status !== 200) {
        // Handle non-200 response status
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
        return // Exit early if the response is not successful
      }

      // Success
      const accessToken = response?.res?.data?.access_token
      updatePaymentStatus(accessToken)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    } finally {
      setLoading(false) // Ensure loading is set to false in all cases
    }
  }, [dispatch, updatePaymentStatus])

  const updatePaymentStatus = useCallback(
    async (token) => {
      setLoading(true)
      const requestBody = {
        output,
      }

      try {
        const response = await verifyPaymentStatus(token, requestBody)

        if (response?.res?.status !== 200) {
          // Handle non-200 response status
          setLoading(false)
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message:
                NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
            })
          )
          return // Exit early if the response is not successful
        }

        // Success
        const responseData = response?.res?.data
        setLoading(false) // Set loading to false after processing the response

        if (responseData?.paymentStatus) {
          history.push(
            `/individual/dashboard/buyPolicy/payment-status/success?policyNumber=${responseData?.policyNumber}&transactionNumber=${responseData?.transactionNumber}`
          )
        } else {
          history.push(
            `/individual/dashboard/buyPolicy/payment-status/failure?policyNumber=${responseData?.policyNumber}&transactionNumber=${responseData?.transactionNumber}`
          )
        }
      } catch (err) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: PAYMENT_STATUS,
          })
        )
      }
    },
    [dispatch, output, history]
  )
  useEffect(() => {
    fetchToken()
  }, [fetchToken])

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.container}>
        <Lottie
          animationData={Verifying_Payment}
          loop={true}
          className={classes.digitalizingAnimation}
        />
        <span className={classes.verifyingText}>
          Please wait while we are verifying your payment status ......
        </span>
      </div>
    </>
  )
}

export default VerifyPaymentStatus

const useStyles = makeStyles({
  container: {
    background: COLORS.WHITE,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  digitalizingAnimation: {
    height: '400px',
  },
  verifyingText: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: COLORS.BLACK,
  },
})
